import script from "./transfer.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer.vue?vue&type=script&setup=true&lang=js"

import "./transfer.vue?vue&type=style&index=0&id=0d464923&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d464923"]])

export default __exports__